import React from 'react'
import { isMobile } from 'react-device-detect'
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons'
import {
  $DCprimaryColor,
  DcButton,
  DcDropDown,
  DcInput,
  PixelFactoryContext,
  PixelIcon,
} from 'pixel-base'
import styled from 'styled-components'

import { addPaymentLine } from 'utils/api-routes.util'
import {
  IPixelFactory,
  OrderDetail,
  PaymentMethod,
  IState,
} from '../../../../../../decl.d'
interface IProps {
  state: IState
  detailID: number
  handleClose: () => void
  newOrder: boolean
  newOrderData: OrderDetail
  setNewOrderData: (newOrderData: OrderDetail) => void
  paymentGateways: PaymentMethod[]
}
const AddPayments = (props: IProps) => {
  const {
    state,
    detailID,
    handleClose,
    newOrder,
    newOrderData,
    setNewOrderData,
  } = props
  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [paymentGateways, setPaymentGateways] = React.useState([])
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })
  const [data, setData] = React.useState({
    amount: '',
    currency: '',
    gateway_id: null,
    gateway_name: null,
  })
  const handleSubmit = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault()
    }
    if (newOrder === true) {
      setNewOrderData({
        ...newOrderData,
        payment_lines: [...(newOrderData?.payment_lines || {}), data],
      })
      handleClose()
    } else {
      handleAddNewPayments()
    }
  }

  const handleAddNewPayments = () => {
    showPageLoader()
    addPaymentLine(detailID, data).subscribe((res: any) => {
      hidePageLoader()
      if (res.response.data) {
        showSuccess('Successfully Added')
        handleClose(res.response.data)
      } else {
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response.error)
        }
      }
    })
  }
  const handlePaymentGatewayChange = (e) => {
    setData({
      ...data,
      gateway_id: e.target.value,
      gateway_name: e.target.options[e.target.selectedIndex].text,
    })
  }

  React.useEffect(() => {
    setPaymentGateways(state.paymentGateways)
  }, [state])
  return (
    <>
      <FormContainer>
        <FormGroup>
          <DcDropDown
            dropdownSize={isMobile ? 'sm' : 'md'}
            error={
              error.field === 'gateway_id' && error.error !== ''
                ? error.error
                : null
            }
            options={[
              { title: 'Payment Gateway', id: '' },
              ...paymentGateways,
            ].map((data) => {
              return { label: data.title, value: data.id }
            })}
            name={'gateway_id'}
            value={data.gateway_id}
            onChange={(e) => handlePaymentGatewayChange(e)}
            placeholder={'Payment Gateway'}
          />
          <DcInput
            inputSize={isMobile ? 'small' : 'medium'}
            error={
              error.field === 'amount' && error.error !== ''
                ? error.error
                : null
            }
            required
            min={'0'}
            type={'number'}
            name={'amount'}
            placeholder={'Amount'}
            value={data.amount}
            onChange={(e) => setData({ ...data, amount: e.target.value })}
          />
        </FormGroup>
        <Actions>
          <DcButton
            size={'sm'}
            onClick={() => {
              handleClose()
            }}
            variant="link"
          >
            <PixelIcon
              color={$DCprimaryColor}
              showTooltip
              tooltip="cancel"
              icon={faXmark}
            />
          </DcButton>
          <DcButton
            disabled={!data.gateway_id || !data.amount}
            size="sm"
            onClick={handleSubmit}
            variant="link"
          >
            <PixelIcon
              color={$DCprimaryColor}
              showTooltip
              tooltip="Add"
              icon={faCheck}
            />
          </DcButton>
        </Actions>
      </FormContainer>
    </>
  )
}

const FormContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: center;
  gap: ${isMobile ? '0px' : '10px'};
`

const FormGroup = styled.div<{ flexEnd?: boolean }>`
  display: inline-flex;
  flex-direction: ${isMobile ? 'column' : 'row'};
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.flexEnd ? 'flex-end' : 'center')};
  align-items: flex-start;
  align-content: flex-start;
  width: 75%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
`
const Actions = styled.div`
  display: flex;
  flex-direction: ${isMobile ? 'column' : 'row'};
  justify-content: center;
  align-items: center;
  align-content: center;
  gap: 10px;
  width: 25%;
`
export default AddPayments
